/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
  function patchCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer || cartDrawer.dataset.mobilePatchApplied === 'true') return false;

    cartDrawer.dataset.mobilePatchApplied = 'true';

    const originalOpen = cartDrawer.openCartDrawer.bind(cartDrawer);

    cartDrawer.openCartDrawer = function (forceOpen = false) {
      if (!forceOpen && window.theme && window.theme.isMobile && window.theme.isMobile()) {
        return;
      }

      return originalOpen(forceOpen);
    };

    return true;
  }

  document.addEventListener('DOMContentLoaded', patchCartDrawer);
  document.addEventListener('shopify:section:load', patchCartDrawer);

  setTimeout(patchCartDrawer, 500);
  setTimeout(patchCartDrawer, 1500);


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
